<app-feature-list-container
  title="{{ '+INSTALLATIONS.INSTALLATION.SYSTEM_DETAILS.TITLE' | translate }}"
>
  <div class="feature-grid-container" *ngIf="device" viFeatureGrid viBorderBottom>
    <app-feature-list-item
      *ngIf="isDeviceBoiler"
      data-at-bmu-serial
      label="{{ '+INSTALLATIONS.INSTALLATION.SYSTEM_DETAILS.MODAL.BMU_SERIAL' | translate }}"
      [value]="device?.bmuSerial | dash"
      [editable]="authStore.canEditBmuSerial$ | async"
      (edit)="openBmuSerialModal(device?.bmuSerial)"
      [attr.data-feature]="'device.bmuSerial'"
    >
    </app-feature-list-item>
    <app-feature-list-item
      [attr.data-at-bmu-status]="device?.status | translateDeviceStatus"
      label="{{ '+INSTALLATIONS.INSTALLATION.SYSTEM_DETAILS.MODAL.STATUS' | translate }}"
      [value]="device?.status | translateDeviceStatus"
      [attr.data-feature]="'device.status'"
    ></app-feature-list-item>
    <app-feature-list-item
      data-at-bmu-marketing-name
      label="{{ '+INSTALLATIONS.INSTALLATION.SYSTEM_DETAILS.MODAL.MARKETING_NAME' | translate }}"
      [value]="device.shortDeviceName | dash"
      [attr.data-feature]="'device.shortDeviceName'"
    >
    </app-feature-list-item>
    <app-feature-list-item
      data-at-bmu-status-changed
      label="{{ '+INSTALLATIONS.INSTALLATION.SYSTEM_DETAILS.MODAL.STATUS_CHANGED' | translate }}"
      [value]="device?.editedAt | date: 'short'"
      [attr.data-feature]="'device.editedAt'"
    >
    </app-feature-list-item>
    <app-feature-list-item
      data-at-bmu-type
      label="{{ '+INSTALLATIONS.INSTALLATION.SYSTEM_DETAILS.MODAL.TYPE' | translate }}"
      [value]="device?.modelId | dash"
      [attr.data-feature]="'device.modelId'"
    >
    </app-feature-list-item>
  </div>
</app-feature-list-container>
